window.jQuery = window.$ = $;

import "@styles/main.scss";

import {App} from "@main/app";

window.App = new App();
window.App.run();





